var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoT(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "156px",
    height: "182px",
    viewBox: "0 0 156 182",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shark-Tank",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-21.000000, -8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(21.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.3053763,76.9690113 L66.3053763,127.146462 C66.3053763,132.815721 68.6145759,136.40976 73.2253286,137.917302 C76.7158901,139.063935 81.9039427,139.612816 88.8009558,139.563943 C92.7502987,139.541386 96,142.616621 96,146.500138 L96,171.54187 C96,175.184783 93.1173238,178.203625 89.4241338,178.478066 C65.4566308,180.263807 48.623178,177.466772 38.9199522,170.09448 C28.348865,162.064283 23.065233,147.748277 23.065233,127.146462 L23.065233,76.9690113 L7.64635603,76.9690113 C3.42174432,76.9690113 0,73.6005393 0,69.4501006 L0,43.6677557 C0,39.5135575 3.42174432,36.148845 7.64635603,36.148845 L23.065233,36.148845 L23.065233,21.2764396 C23.065233,11.8853201 29.3275986,3.60699935 38.4726404,0.911469859 C52.3431302,-3.18257703 66.3053763,7.02810373 66.3053763,21.2764396 L66.3053763,36.148845 L88.353644,36.148845 C92.5744325,36.148845 96,39.5135575 96,43.6677557 L96,69.4501006 C96,73.6005393 92.5744325,76.9690113 88.353644,76.9690113 L66.3053763,76.9690113 Z",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#58FDD9",
    cx: 131.5,
    cy: 158,
    rx: 24.5,
    ry: 24
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoT);
export default __webpack_public_path__ + "static/media/logo_t.d1f88ccb3052604a4f3f99c1f1fb6602.svg";
export { ForwardRef as ReactComponent };